export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/copy-paste.8c8e962d.svg","height":64,"width":64};